<template>
    <div class="profile-container">
        <div v-if="loading" style="height: 10px;">
            <b-progress :value="current_counter" :max="100" animated></b-progress>
        </div>
        <CCard bodyWrapper style="width: auto; height: 100vh; margin-top: 109px;" v-bind:class="{ profile_center: !sidebarMinimize, 'profile_minimize': sidebarMinimize }">
            <div class="profile_card2">
                <div class="sub_profile_card2">
                    <CInput
                        class="user_name_label"
                        :label="$t('Username')"
                        :value="loggedInUser.display_name"
                        plaintext
                        readonly
                    />
                    <hr class="profile_hr"/>
                    <div class="form-group user-avatar-wrapper">
                        <label class="select_avatar_label">{{ $t('Select Avatar') }}</label>
                        <div class="user-avatar">
                            <cropper
                                :boundary="{
                                    width: 220,
                                    height: 220
                                }"
                                :viewport="{
                                    width: 200,
                                    height: 200
                                }"
                                :resize="false"
                                :defaultAvatarSrc="imageUrl"
                                :zoom="true"
                                @cropped="cropped"
                            />
                        </div>
                    </div>
                    <hr class="profile_hr"/>
                    <CInput
                        class="alias_label"
                        :key="JSON.stringify(loggedInUser)"
                        :label="$t('Alias')"
                        :value="model.alias"
                        :isValid="validationState['alias'] && validationState['alias'].state"
                        :invalidFeedback="validationState['alias'] && validationState['alias'].text"
                        @update:value="model.alias=$event, validateField('alias')"
                    />
                    <hr class="profile_hr"/>
                    <div class="d-flex justify-content-end save_changes_profile action-btns">
                        <CButton
                            color="info"
                            class="m-2"
                            :disabled="loading"
                            @click="handleUpdate"
                            style="background-color: #3399ff !important;"
                        >
                            {{ $t('Save changes') }}
                            <CSpinner v-if="loading" color="danger" size="sm" />
                        </CButton>
                    </div>
                </div>
            </div>
        </CCard>
    </div>
</template>

<script>
    import { mapState, mapActions, mapGetters } from 'vuex';

    import Cropper from "@/components/Cropper";
    import {VUE_APP_URL} from '@/config';
    import {displaySuccess, displayError} from '@/helpers/message';
    import validationMixin from '@/mixins/common/validationMixin';

    export default {
        name: 'PostTip',
        mixins: [validationMixin],
        components: {
            Cropper,
        },
        data () {
            return {
                model: {
                    alias: '',
                    avatar: ''
                },
                loading: false,
                loadingTimer: '',
                show: false,
                validationState: {},
            }
        },
        computed: {
            ...mapState(['sidebarMinimize']),
            ...mapGetters(['loggedInUser']),
            imageUrl() {
                let result = 'img/avatars/default-avatar.jpg';
                let storedUrl = localStorage.getItem('storedAvatar');
                if(storedUrl)
                    result = storedUrl;
                if(this.loggedInUser.avatar)
                    result = this.loggedInUser.avatar;
                if(this.imgDataUrl)
                    result = this.model.avatar;
                return result;
            },
            validationRules() {
                return {
                    alias: [{
                        minLength: 5,
                        maxLength: 12,
                        message: 'Alias name must have a number between 5 and 12 letters!'
                    }, {
                        unique: true,
                        message: 'Someone is already using this alias!',
                        func: this.checkAliasIfDuplicate
                    }]
                }
            }
        },
        methods: {
            ...mapActions([
                'updateProfile',
                'checkAliasIfDuplicate'
            ]),
            async handleUpdate() {
                this.loading = true;
                const isValid = await this.checkValidation();
                if(!isValid)
                    return;
                let params = {};
                if(this.model.avatar) {
                    params['avatar'] = this.model.avatar;
                }
                params['alias'] = this.model.alias;
                if(!this._.isEmpty(params)) {
                    
                    this.updateProfile(params).then(res => {
                        this.model.avatar = '';
                        this.loading = false;
                        displaySuccess(res);
                    }).catch(err => {
                        displayError(res);
                    });
                }
                else {
                    this.loading = false;
                }
            },
            cropped(e) {
                this.model.avatar = e;
            },
        },
        watch: {
            loggedInUser: {
                deep: true,
                immediate: true,
                handler(val) {
                    this.model.alias = this.loggedInUser.alias;
                }
            }
        },
        mounted() {
        },
        created() {
            
        },
        beforeDestroy() {

        }
    }
</script>
<style lang="scss" scoped>
    .profile_hr {
        width: 100%;
    }
    .profile_card2 {
        padding: 5px;
        background-color: #f5f5f5;
        border-radius: 10px;
        border: 1px solid #e2e2e2;
        width: 100%;
        display: flex;
        justify-content: center;
    }
    .sub_profile_card2 {
        width: 250px;
        padding: 15px 0;
    }
    .user-avatar-wrapper {
        margin: 0;   
    }
    .user-avatar {
        display: flex;
        justify-content: center;
    }
    user-avatar-wrapper user-avatar {
        display: flex;
        justify-content: center;
    }
    .profile-container {
        position: absolute;
        top: 0px;
        right: 0px;
        bottom: 0px;
        left: 0px;
            
        .card-body {
            display: flex;
            flex-direction: column;
            align-items: center;

            .form-group {
                width: 100%;
            }
        }
    }
    
    .avatar-box[data-v-f2975fe6] {
        margin: auto !important;
        background: none;
    }
    .save_changes_profile{
        display: block !important;
        text-align: center;
    }

    .user_name_label,
    .select_avatar_label, 
    .alias_label{
        color: #321fdb;
        font-weight: 700;
        font-size: 20px;
    }
    .user_name_label label, .user_name_label input {
        margin: 0 !important;
        padding: 0 !important;
    }
    // .profile_center, .profile_minimize {
    //     margin-left: 0;
    // }
    @media (min-width: 992px) {
        .profile_center {
            margin-left: 194px;
        }
        .profile_minimize {
            margin-left: 56px;
        }
    }

    @media (max-width: 576px){
        .profile_center > div:first-child{
            margin-left: 0;
        }
    }
    @media (max-width: 768px) {
        .profile_center {
            margin-left: 2px;
        }
       .profile_minimize {
           margin-left: 2px;
       }
    }
</style>